module.exports = __webpack_public_path__ + "static/media/castello-branco-advogados-associados-logo-branding.e367cb5b.jpg";